import _ from 'lodash';

import { set, toggle } from '@/utils/vuex';
import router from '@/router';
import Users from '@/services/resources/users_service';
import Sites from '@/services/resources/sites_service';
import Permissions from '@/services/resources/permissions_service';

const mutations = {
  setDrawer: set('drawer'),
  setActiveSite(state, payload) {
    state.activeSite = payload;
    window.localStorage.activeSite = payload;
    router.push(`/sites/${payload}/dashboard`).catch(() => {});
  },
  setGroupReportSites(state, payload) {
    state.groupReportSites = payload;
    window.localStorage.groupReportSites = JSON.stringify(payload);
  },
  setActiveUser(state, payload) {
    const user = Users.model.options.deserializer(payload);
    state.activeUser = user;
    window.localStorage.activeUser = JSON.stringify(user);
  },
  setSitesAndPermissions(state, payload) {
    const sites = [];
    const permissions = [];
    const manufacturers = [];
    payload.forEach((included) => {
      if (included.type === 'sites') {
        sites.push(included);
      } else if (included.type === 'permissions') {
        permissions.push(included);
      } else if (included.type === 'chemical-manufacturers') {
        manufacturers.push(included);
      }
    });

    state.sites = _.sortBy(
      sites.map((site) => {
        return Sites.model.options.deserializer(site, manufacturers);
      }),
      'name',
    );
    window.localStorage.sites = JSON.stringify(state.sites);

    state.permissions = permissions.map((permission) => {
      return Permissions.model.options.deserializer(permission, [...sites, ...manufacturers]);
    });
    window.localStorage.permissions = JSON.stringify(state.permissions);
  },
  setAuthToken(state, payload) {
    const token = payload.split(' ')[1];
    state.authToken = token;
    window.localStorage.authToken = token;
  },
  logout() {
    window.localStorage.removeItem('authToken');
    window.localStorage.removeItem('activeSite');
    window.localStorage.removeItem('activeUser');
    window.localStorage.removeItem('sites');
    window.localStorage.removeItem('permissions');
    window.location.href = '/login'; // best way to reset all state
  },
  toggleDrawer: toggle('drawer'),
  setToast: set('toast'),
  successToast(state, payload) {
    return (state.toast = {
      active: true,
      status: 'success',
      text: payload,
    });
  },
  infoToast(state, payload) {
    return (state.toast = {
      active: true,
      status: 'info',
      text: payload,
    });
  },
  failToast(state, payload) {
    return (state.toast = {
      active: true,
      status: 'error',
      text: payload,
    });
  },
};

export default mutations;
